import FlowTable from "./FlowTable";
import LoaderHOC from "../hoc/LoaderHOC";

/**
 * Komponent tabeli z loaderem
 */
export default LoaderHOC(FlowTable);
